import type { MindMapNode } from '@/model/types';

/**
 * Convert a mind map tree to an indented plain text outline.
 * Each node is a line, indented with tabs based on depth.
 */
export function exportTextOutline(nodes: Map<string, MindMapNode>, rootNodeId: string): string {
  const lines: string[] = [];
  const root = nodes.get(rootNodeId);
  if (!root) return '';

  walkNode(root, 0, nodes, lines);
  return lines.join('\n') + '\n';
}

function walkNode(
  node: MindMapNode,
  depth: number,
  nodes: Map<string, MindMapNode>,
  lines: string[],
): void {
  const indent = '\t'.repeat(depth);
  lines.push(`${indent}${node.text}`);

  for (const childId of node.childIds) {
    const child = nodes.get(childId);
    if (child) {
      walkNode(child, depth + 1, nodes, lines);
    }
  }
}
